<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin:0;
  padding:0;
}
#app {
  width:100%;
  min-width: 1400px;
  height:100%;
  text-align: center;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue